import styled from 'styled-components';

const NoResultsTextDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${p => p.theme.c.text.primary};
  margin: ${p => p.theme.unit(4)} 0;
`;

const SearchResultsEmptyState = (props) => {
  const {
    searchQuery,
    noResultsText,
  } = props;

  return (
    <NoResultsTextDiv>
      {noResultsText}
      <span>{` "${searchQuery}"`}</span>
    </NoResultsTextDiv>
  );
};

export default SearchResultsEmptyState;
